import { Box, Button, ButtonProps, Skeleton, Typography } from '@mui/material'
import CustomerIcon from '@mui/icons-material/PermContactCalendar'
export interface CustomerButtonUIProps extends ButtonProps {
    onClick: () => void
    title: string
    hideIcon?: boolean
    textColor?: string
    maxWidth?: string
}
function CustomerButtonUI({
    onClick,
    title,
    hideIcon = false,
    textColor = 'text.primary',
    maxWidth = '100px',
    ...buttonProps
}: CustomerButtonUIProps) {
    return (
        <Box color={textColor}>
            <Button
                variant="text"
                onClick={(e) => {
                    e.stopPropagation()
                    onClick()
                }}
                sx={{
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                    width: 'auto',
                    color: 'inherit',
                }}
                startIcon={hideIcon ? undefined : <CustomerIcon />}
                {...buttonProps}
            >
                <Typography
                    style={{
                        maxWidth: maxWidth,
                        overflow: 'hidden',
                        whiteSpace: 'nowrap',
                        textOverflow: 'ellipsis',
                    }}
                    align="left"
                >
                    {title ? (
                        title
                    ) : (
                        <Skeleton variant="rounded" width={60} height={15} />
                    )}
                </Typography>
            </Button>
        </Box>
    )
}

export default CustomerButtonUI
